import { Avatar, Box, Button, Card, CardContent, Container, Grid, MenuItem, TextField, Typography, styled } from "@mui/material";
import Logo from "../../../assets/logo.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import PhoneIcon from "@mui/icons-material/Phone";
import LoginIcon from "@mui/icons-material/Login";
import { useEffect, useMemo, useState } from "react";
import { LoadingButton } from "@mui/lab";
import * as Yup from 'yup';
import { Form, FormikProvider, useFormik } from "formik";
import { CardElement, Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import toast, { Toaster } from "react-hot-toast";
import { BOOKING_APPOINTMENT_DETAILS, CHARGE_TIP } from "../../api";
import { getTenantStripePromise } from "../../utils/stripe";
import axios from "../../../axios";
import { ArrowBack } from "@mui/icons-material";
import { apiPathUrl } from '../../utils/config';
import useAuth from '../../hooks/useAuth';
const MainBox = styled(Box)(({ theme }) => ({
    "& .topHeader": {
      position: "fixed",
      width: "100%",
      backgroundColor: "#fff",
      zIndex: "999",
      boxShadow:
        "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
      "& .logoContainer": {
        padding: "5px 0 2px 0",
        "& img": {
          width: "200px",
        },
      },
      "& .signInBtn": {
        color: "#3498db",
        fontSize: "1rem",
        fontWeight: "600",
      },
      "& .currentUser": {
        border: "none",
        background: "transparent",
        cursor: "pointer",
        padding: "0.25rem 0.4rem",
        borderRadius: "8px",
        "&:hover": {
          backgroundColor: "#f4f8fc",
        },
      },
      "& .bodyTxt": {
        color: "#3498db",
        paddingRight: "0.3rem",
      },
    },
    "& .contentMain": {
      paddingTop: "8rem",
      "& .bookingTitle": {
        textAlign: "center",
        fontWeight: "bold",
        paddingBottom: "1rem",
        paddingTop: "1rem",
      },
      "& .coverImage": {
        width: "100%",
      },
      "& .tell-us": {},
      "& .subHeadings": {
        fontWeight: "bold",
        fontSize: "1.4rem",
        paddingTop: "1rem",
        paddingBottom: "1rem",
      },
    },
  }));

export const ChargeTip = () => {
  const stripePromise = useMemo(() => getTenantStripePromise(), []);
    const navigate = useNavigate();
    const { isAuthenticated, user } = useAuth();
    const [tipAmmount, setTipAmmount] = useState(0);
    const [customTip, setCustomTip] = useState(null);
    const [selectedTip, setSelectedTip] = useState('no')
    const [step, setStep] = useState(1)
    const [loading, setLoading] = useState(false);
  const [stripe, setStripe] = useState(null);
  const [elements, setElements] = useState(null);
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get("booking_id");
  const cleanerId = searchParams.get("cleaner_id");
  const [assignedCleaners, setAssignedCleaners] = useState([]);
  const [selectedCleanerIds, setSelectedCleanerIds] = useState(cleanerId ? [Number(cleanerId)] : []);
  const [cleanersLoading, setCleanersLoading] = useState(Boolean(bookingId));
  const [cleanersError, setCleanersError] = useState(false);
  const userName = user?.full_name?.trim()
    || `${user?.user_profile?.first_name || ''} ${user?.user_profile?.last_name || ''}`.trim()
    || user?.email
    || 'Account';
  const userRole = user?.role || user?.user_profile?.role || '';
  const userInitials = userName
    .split(/\s+/)
    .map((part) => part?.[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

  useEffect(() => {
    if (!bookingId) {
      setCleanersLoading(false);
      return;
    }

    let active = true;
    setCleanersLoading(true);
    setCleanersError(false);
    axios
      .get(`${apiPathUrl}${BOOKING_APPOINTMENT_DETAILS}/${encodeURIComponent(bookingId)}`)
      .then((response) => {
        if (!active) return;
        const cleaners = (response?.data?.data?.dispatch || [])
          .map((dispatch) => dispatch?.service_provider)
          .filter(Boolean)
          .map((provider) => ({
            id: typeof provider === 'object' ? provider?.id : provider,
            name: typeof provider === 'object'
              ? `${provider?.user_profile?.first_name || ''} ${provider?.user_profile?.last_name || ''}`.trim() || provider?.email || `Cleaner ${provider?.id}`
              : `Cleaner ${provider}`,
          }))
          .filter((provider, index, list) => provider.id && list.findIndex((item) => item.id === provider.id) === index);

        setAssignedCleaners(cleaners);
        setSelectedCleanerIds(cleaners.length === 1 ? [cleaners[0].id] : []);
      })
      .catch(() => {
        if (!active) return;
        setCleanersError(true);
        setAssignedCleaners([]);
        setSelectedCleanerIds(cleanerId ? [Number(cleanerId)] : []);
      })
      .finally(() => {
        if (active) setCleanersLoading(false);
      });

    return () => {
      active = false;
    };
  }, [bookingId, cleanerId]);


  const schema = Yup.object().shape({
    name: Yup.string().required('Full name is required!'),
  });
  const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        border: '1px solid gray',
        color: '#303238',
        fontSize: '16px',
        fontFamily: 'sans-serif',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#818082',
        },
      },
      invalid: {
        color: '#e5424d',
        ':focus': {
          color: '#303238',
        },
      },
    },
  };
  const formik = useFormik({
    initialValues: {
      name: '',
      token_id: '',
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        if (stripe && elements) {
          const cardElement = elements.getElement(CardElement);
          const result = await stripe.createToken(cardElement, {
            name: values.name,
          });
          if (result.error) {
            setLoading(false);
            toast.error(result.error.message);
            setFieldValue('token', '');
          } else if (bookingId) {
            setFieldValue('token', result.token.id);

            const objToSend = {
              booking_id: bookingId,
              amount: Number.isFinite(Number(tipAmmount)) ? Number(tipAmmount) : 0,
              token_id: result.token.id,
            };
            objToSend.cleaner_id = selectedCleanerIds.map(Number);
            toast.promise(
              axios.post(`${apiPathUrl}${CHARGE_TIP}`, objToSend, {
                headers: { 'Content-Type': 'application/json' },
              }),
              {
                loading: () => {
                  return `Adding Card!`;
                },
                success: (res) => {
                  setLoading(false);
                  resetForm();
                  navigate('/dashboard/default');
                  return res?.data?.message;
                },
                error: (err) => {
                  setLoading(false);
                  return err?.message;
                },
              }
            );
          }
        } else {

        }
      } catch (error) {
        console.log('in error', error);
        setLoading(false);
      }
    },
  });

  const { errors, touched, resetForm, handleSubmit, getFieldProps, setFieldValue } = formik;

    const handleContinue = () => {
      if (cleanersLoading) {
        toast.error('Please wait while assigned cleaners are loading.');
        return;
      }
      if (!selectedCleanerIds.length) {
        toast.error('Please select at least one assigned cleaner.');
        return;
      }
      setStep(2)
    };

    const handleTipOption = (value) => {
      setSelectedTip(value);
      setTipAmmount(value === 'no' ? 0 :
      value === '35%' ? 5.63 : 
      value === '25%' ? 4.02 : 
      value === '20%' ? 3.22 : 
      value === 'custom' ? customTip  || 0: 0);
    }

    return (
        <>
      <MainBox>
      <Box className="topHeader">
        <Container maxWidth="lg">
          <Box
            display={"flex"}
            alignItems="center"
            justifyContent={"space-between"}
          >
            <Box className="logoContainer">
              <a href="/dashboard/default">
                <img
                  src={Logo}
                  alt="logo"
                  className="logoImg"
                  style={{ cursor: "pointer" }}
                />
              </a>
            </Box>
            <Box display={"flex"} alignItems="center">
              <Box display={"flex"} alignItems="center">
                <PhoneIcon className="bodyTxt" />
                <Typography
                  variant="body1"
                  className="bodyTxt"
                  style={{ cursor: "pointer" }}
                >
                  {/* +1(212)851-6134 */}
                  <a href="tel:+12128516134">+1(212)851-6134</a>
                </Typography>
              </Box>
              <Box display={"flex"} alignItems="center" sx={{ marginLeft: "1rem" }}>
                {isAuthenticated && user ? (
                  <Box
                    component="button"
                    type="button"
                    className="currentUser"
                    display="flex"
                    alignItems="center"
                    gap={1}
                    onClick={() => navigate('/dashboard/default')}
                    aria-label={`Open dashboard for ${userName}`}
                  >
                    <Avatar
                      src={user?.avatar}
                      sx={{ width: 34, height: 34, bgcolor: '#0b4ca8', fontSize: 12, fontWeight: 700 }}
                    >
                      {userInitials}
                    </Avatar>
                    <Box sx={{ textAlign: 'left', display: { xs: 'none', sm: 'block' } }}>
                      <Typography sx={{ color: '#07154a', fontSize: 12, fontWeight: 700, lineHeight: 1.2 }}>
                        {userName}
                      </Typography>
                      {userRole && (
                        <Typography sx={{ color: '#64748b', fontSize: 10, lineHeight: 1.2 }}>
                          {userRole}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                ) : (
                  <Button
                    variant="text"
                    startIcon={<LoginIcon />}
                    onClick={() => navigate(`/session/signin`)}
                    className="signInBtn"
                  >
                    Sign in
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
      <Container maxWidth="lg" className="contentMain">
      <Card>
        {step === 1 ? <CardContent>
        <Typography variant="h6" gutterBottom textAlign={'center'}>
          Would you like to leave a tip?
        </Typography>
        <Typography variant="h5" gutterBottom textAlign={'center'}>
          ${tipAmmount}
        </Typography>
        <Grid container spacing={3}>
          <Grid container item xs={12} gap={'10px'} justifyContent={'center'}>
            <Grid item>
              <Box sx={{
                height: '80px',
                width: '120px',
                background: selectedTip === 'no' ? '#1976d2' : '#e8e8e8',
                color: selectedTip === 'no' ? '#ffffff' : '#121212',
                cursor: 'pointer',
                borderRadius: '5px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }} onClick={() => {
                handleTipOption('no');
              }}>
                No Tip
              </Box>
            </Grid>
            <Grid item>
              <Box sx={{
                height: '80px',
                width: '120px',
                background: selectedTip === '35%' ? '#1976d2' : '#e8e8e8',
                color: selectedTip === '35%' ? '#ffffff' : '#121212',
                cursor: 'pointer',
                borderRadius: '5px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }} onClick={() => {
                handleTipOption('35%');
              }}>
                <Typography variant="h6">35%</Typography>
                $5.63
              </Box>
            </Grid>
            <Grid item>
              <Box sx={{
                height: '80px',
                width: '120px',
                background: selectedTip === '25%' ? '#1976d2' : '#e8e8e8',
                color: selectedTip === '25%' ? '#ffffff' : '#121212',
                cursor: 'pointer',
                borderRadius: '5px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }} onClick={() => {
                handleTipOption('25%');
              }}>
                <Typography variant="h6">25%</Typography>
                $4.02
              </Box>
            </Grid>
            <Grid item>
              <Box sx={{
                height: '80px',
                width: '120px',
                background: selectedTip === '20%' ? '#1976d2' : '#e8e8e8',
                color: selectedTip === '20%' ? '#ffffff' : '#121212',
                cursor: 'pointer',
                borderRadius: '5px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }} onClick={() => {
                handleTipOption('20%');
              }}>
                <Typography variant="h6">20%</Typography>
                $3.22
              </Box>
            </Grid>
            <Grid item>
              <Box sx={{
                height: '80px',
                width: '120px',
                background: selectedTip === 'custom' ? '#1976d2' : '#e8e8e8',
                color: selectedTip === 'custom' ? '#ffffff' : '#121212',
                cursor: 'pointer',
                borderRadius: '5px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }} onClick={() => {
                handleTipOption('custom');
              }}>
                Custom Tip
              </Box>
            </Grid>
          </Grid>
          {selectedTip === 'custom' && <Grid item xs={12} display={'flex'} justifyContent={'center'}>
            <TextField sx={{
              width: '40rem'
            }} id="customTip" label="Custom Tip" inputProps={{
              min: 1,
            }} value={customTip} type="number" onChange={(e) => {
              const nextAmount = e.target.value === '' ? '' : Number(e.target.value);
              setCustomTip(nextAmount);
              setTipAmmount(nextAmount);
            }} />
          </Grid>}
          {cleanersLoading && (
            <Grid item xs={12}>
              <Typography textAlign="center" color="text.secondary">
                Loading assigned cleaners...
              </Typography>
            </Grid>
          )}
          {!cleanersLoading && assignedCleaners.length > 1 && (
            <Grid item xs={12} display={'flex'} justifyContent={'center'}>
              <TextField
                select
                label="Select Cleaners"
                value={selectedCleanerIds}
                onChange={(event) => setSelectedCleanerIds(event.target.value)}
                SelectProps={{
                  multiple: true,
                  renderValue: (selected) => assignedCleaners
                    .filter((cleaner) => selected.includes(cleaner.id))
                    .map((cleaner) => cleaner.name)
                    .join(', '),
                }}
                sx={{ width: '40rem' }}
              >
                {assignedCleaners.map((cleaner) => (
                  <MenuItem key={cleaner.id} value={cleaner.id}>
                    {cleaner.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
          {!cleanersLoading && cleanersError && !selectedCleanerIds.length && (
            <Grid item xs={12}>
              <Typography textAlign="center" color="error" fontSize="0.875rem">
                Assigned cleaners could not be loaded. Please try again.
              </Typography>
            </Grid>
          )}
          {!cleanersLoading && !cleanersError && assignedCleaners.length === 0 && (
            <Grid item xs={12}>
              <Typography textAlign="center" color="error" fontSize="0.875rem">
                No cleaner is assigned to this booking. Please assign a cleaner before charging a tip.
              </Typography>
            </Grid>
          )}
          <Grid item xs={12} display={'flex'} justifyContent={'center'}>
            <Button sx={{
              width: '40rem'
            }} variant="contained" color="primary" onClick={handleContinue}
              disabled={!cleanersLoading && !cleanersError && assignedCleaners.length === 0}>
              Continue
            </Button>
          </Grid>
        </Grid>
      </CardContent> : <CardContent>
        <Box sx={{display: 'flex'}}><Box sx={{width: 'fit-content', cursor: 'pointer'}} onClick={() => setStep(1)}><ArrowBack /></Box>
        <Typography sx={{flexGrow: 1}} variant="h6" gutterBottom textAlign={'center'}>
          Please enter your card information!
        </Typography>
        </Box>
        
        <Typography variant="h5" gutterBottom textAlign={'center'}>
          ${tipAmmount}
        </Typography>
        <Box sx={{
          width: '40rem',
          margin: 'auto',
        }}>
        <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Box
                sx={{
                  marginBottom: '10px',
                }}
              >
                <TextField
                  size="medium"
                  fullWidth
                  type="text"
                  inputProps={{ placeholder: 'Name (Required)' }}
                  {...getFieldProps('name')}
                  error={Boolean(touched.name && errors.name)}
                  helperText={touched.name && errors.name}
                />
              </Box>
              <Elements stripe={stripePromise}>
                <ElementsConsumer>
                  {({ stripe, elements }) => (
                    <>
                      <Box
                        sx={{
                          borderRadius: '4px',
                          border: Boolean(errors.token)
                            ? '1px solid #e5424d'
                            : '1px solid rgba(0, 0, 0, 0.23);',
                        }}
                      >
                        <CardElement
                          options={CARD_ELEMENT_OPTIONS}
                          onReady={(element) => {
                            setElements(elements);
                          }}
                          onChange={(event) => {
                            setStripe(stripe);
                          }}
                        />
                      </Box>
                      {Boolean(errors.token) && (
                        <Box
                          sx={{
                            color: '#FF3D57',
                            fontWeight: '400',
                            fontSize: '0.75rem',
                            letterSpacing: '0.03333em',
                            marginTop: '4px',
                            marginBottom: '0',
                            marginLeft: '14px',
                          }}
                        >
                          {errors.token}
                        </Box>
                      )}
                      <Typography fontSize={'14px'} color={'#8a94a9'} marginTop={'20px'}>
                        I authorize the operator to send instructions to the financial
                        institution that issued my card to take payments from my card account
                        in accordance with the terms of my agreement with you.
                      </Typography>
                    </>
                  )}
                </ElementsConsumer>
              </Elements>
              <Box
                display={'flex'}
                alignItems="center"
                justifyContent={'end'}
                sx={{ mb: 2, mt: 3 }}
              >
                <LoadingButton type="submit" color="primary" loading={loading} variant="contained">
                  Charge Now
                </LoadingButton>
              </Box>
            </Form>
          </FormikProvider>
        </Box>
      </CardContent>}
      
    </Card>
      </Container>
      </MainBox>
      <Toaster position="top-right" />
    </>
)}
